"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ToggleSwitch = _interopRequireDefault(require("@insided/shared/uikit/ToggleSwitch"));

var _dropdown = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/dropdown"));

var _NestedDropdown = _interopRequireDefault(require("@insided/shared/uikit/NestedDropdown"));

var _SearchBox = _interopRequireDefault(require("@insided/deprecated-preact-components/search-box/SearchBox"));

var _chip = require("@insided/deprecated-preact-components/design-system-components/chip");

var _listGroup = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/list-group"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _Eye = _interopRequireDefault(require("@insided/destination/icons/Eye"));

var _ProductCommunity = _interopRequireDefault(require("@insided/destination/icons/ProductCommunity"));

var _ProductSkilljar = _interopRequireDefault(require("@insided/destination/icons/ProductSkilljar"));

var _ReorderContent = _interopRequireDefault(require("./ReorderContent"));

var _utils = require("../utils");

var _Move = _interopRequireDefault(require("@insided/destination/icons/Move"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MAX_VISIBLE_ITEMS = 6; // Filter items by search value

var filterItems = function filterItems(items) {
  var searchValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!searchValue) {
    return items;
  }

  var searchLower = searchValue.toLowerCase();
  return items.filter(function (item) {
    return item.name.toLowerCase().includes(searchLower);
  });
}; // Convert WidgetSetting[] to NestedItem[] for NestedDropdown


var convertToNestedItems = function convertToNestedItems(items) {
  return items.map(function (item) {
    return {
      id: (0, _utils.getItemUniqueId)(item),
      title: item.name,
      children: []
    };
  });
};

var ProductVisibilitySection = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ProductVisibilitySection, _Component);

  var _super = _createSuper(ProductVisibilitySection);

  function ProductVisibilitySection() {
    var _this;

    (0, _classCallCheck2.default)(this, ProductVisibilitySection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      searchValue: '',
      isReorderMode: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSearchChange", function (value) {
      _this.setState({
        searchValue: value
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDropdownOpen", function () {
      // Reset search when dropdown opens (fresh start each time)
      _this.setState({
        searchValue: ''
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onItemToggle", function (itemId, checked) {
      _this.props.onItemSelectionChange(String(itemId), checked);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onReorderClick", function () {
      _this.setState({
        isReorderMode: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onReorderConfirm", function (reorderedItems) {
      _this.props.onItemsReorder(reorderedItems);

      _this.setState({
        isReorderMode: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onReorderCancel", function () {
      _this.setState({
        isReorderMode: false
      });
    });
    return _this;
  }

  (0, _createClass2.default)(ProductVisibilitySection, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          label = _this$props.label,
          iconName = _this$props.iconName,
          megaMenuVisible = _this$props.megaMenuVisible,
          selectedItems = _this$props.selectedItems,
          availableItems = _this$props.availableItems,
          onToggleMegaMenuVisible = _this$props.onToggleMegaMenuVisible,
          onItemRemove = _this$props.onItemRemove;
      var _this$state = this.state,
          searchValue = _this$state.searchValue,
          isReorderMode = _this$state.isReorderMode; // Get display names for selected items
      // selectedItems contains unique item identifiers (item.id), we look up the name from availableItems
      // All items should have names since WidgetSetting.name is required, and syncSelectedItems ensures valid items

      var selectedItemLabels = selectedItems.map(function (uniqueId) {
        var item = availableItems.find(function (item) {
          return (0, _utils.getItemUniqueId)(item) === uniqueId;
        });
        return (item === null || item === void 0 ? void 0 : item.name) || uniqueId; // Should always find item, but fallback to ID if not found
      }); // Filter available items by search

      var filteredItems = filterItems(availableItems, searchValue); // Render appropriate icon based on iconName

      var renderIcon = function renderIcon() {
        if (iconName === 'community') {
          return (0, _preact.h)(_ProductCommunity.default, {
            width: 40,
            height: 40
          });
        } else if (iconName === 'skilljar') {
          return (0, _preact.h)(_ProductSkilljar.default, {
            width: 40,
            height: 40
          });
        } // Fallback to placeholder


        return (0, _preact.h)("div", {
          className: "product-shared-visibility-section-icon-placeholder"
        }, label.charAt(0));
      };

      return (0, _preact.h)("div", {
        className: "product-shared-visibility-section"
      }, (0, _preact.h)("div", {
        className: "product-shared-visibility-section-header"
      }, (0, _preact.h)("div", {
        className: "product-shared-visibility-section-icon"
      }, renderIcon()), (0, _preact.h)("div", {
        className: "product-shared-visibility-section-title"
      }, label)), (0, _preact.h)("div", {
        className: "product-shared-visibility-section-toggle"
      }, (0, _preact.h)("div", {
        className: "product-shared-visibility-section-toggle-label"
      }, (0, _preact.h)(_Eye.default, {
        width: 24,
        height: 24
      }), (0, _preact.h)("span", null, "Mega Menu content visible")), (0, _preact.h)(_ToggleSwitch.default, {
        checked: megaMenuVisible,
        onChange: onToggleMegaMenuVisible
      })), (0, _preact.h)("div", {
        className: "product-shared-visibility-section-contents"
      }, isReorderMode ? (0, _preact.h)(_ReorderContent.default, {
        selectedItems: selectedItems,
        availableItems: availableItems,
        onConfirm: this.onReorderConfirm,
        onCancel: this.onReorderCancel
      }) : (0, _preact.h)("div", {
        className: "product-shared-visibility-section-contents-normal-view"
      }, (0, _preact.h)("div", {
        className: "product-shared-visibility-section-contents-header"
      }, (0, _preact.h)("span", null, "Contents"), (0, _preact.h)("button", {
        className: "product-shared-visibility-section-contents-reorder-button",
        onClick: this.onReorderClick,
        type: "button",
        "aria-label": "Reorder contents",
        title: "Reposition content"
      }, (0, _preact.h)(_Move.default, {
        width: 24,
        height: 24
      }))), (0, _preact.h)("div", {
        className: "product-shared-visibility-section-contents-tags"
      }, (0, _preact.h)(_listGroup.default, {
        spacing: "4px"
      }, selectedItemLabels.slice(0, MAX_VISIBLE_ITEMS).map(function (label, index) {
        var itemKey = selectedItems[index];
        return (0, _preact.h)(_chip.Chip, {
          key: itemKey,
          variant: "squared",
          size: "small",
          endIcon: (0, _preact.h)(_Close.default, {
            width: 16,
            height: 16
          }),
          onClick: function onClick() {
            return onItemRemove(itemKey);
          }
        }, label);
      }), selectedItemLabels.length > MAX_VISIBLE_ITEMS && (0, _preact.h)(_chip.Chip, {
        variant: "squared",
        size: "small"
      }, "+", selectedItemLabels.length - MAX_VISIBLE_ITEMS)), (0, _preact.h)("div", {
        className: "product-shared-visibility-section-contents-dropdown-wrapper"
      }, (0, _preact.h)(_dropdown.default, {
        className: "dropdown-selector product-shared-visibility-dropdown-selector",
        popupName: "product-shared-visibility-selection",
        closeOnDropdownClick: false,
        size: "M",
        trigger: (0, _preact.h)("button", {
          type: "button",
          className: "product-shared-visibility-section-contents-dropdown-trigger",
          onClick: this.onDropdownOpen,
          "aria-label": "Open dropdown to select items"
        }, (0, _preact.h)(_ChevronDown.default, {
          width: 24,
          height: 24
        }))
      }, (0, _preact.h)(_SearchBox.default, {
        isModerationOverview: true,
        placeholder: "Search placeholder",
        value: searchValue,
        onSubmit: function onSubmit() {},
        onInput: function onInput(e) {
          return _this2.onSearchChange(e.target.value);
        },
        onClear: function onClear() {
          return _this2.onSearchChange('');
        }
      }), filteredItems.length === 0 && searchValue ? (0, _preact.h)("div", {
        className: "empty-list-message"
      }, "No results found") : (0, _preact.h)(_NestedDropdown.default, {
        labelId: "product-visibility",
        items: convertToNestedItems(filteredItems),
        onMultiSelect: this.onItemToggle,
        selectedItems: selectedItems,
        depth: 1
      })))))));
    }
  }]);
  return ProductVisibilitySection;
}(_preact.Component);

var _default = ProductVisibilitySection;
exports.default = _default;